import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { GetDojoName, GetGradeName } from "../Utils";

export default function QualifyDateDetail(props) {
  let params = useParams();
  const dateId = params.id;

  const STATE_APPROVED = "NEW";
  const STATE_CREATED = "CREATED";
  const STATE_UPDATED = "UPDATED";
  const STATE_NOTAPPROVED = "NOTAPPROVED";
  const STATE_ABSENT = "ABSENT";

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);

  const [detail, setDetail] = useState(null);
  const [exams, setExams] = useState([]);
  const [canQualify, setCanQualify] = useState(false);

  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));
  const history = useHistory();

  useEffect(() => {
    GetExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetExams = async () => {
    setLoading(true);

    const dojosList = JSON.parse(ls.get("dojos"));
    const gradesList = JSON.parse(ls.get("grades"));

    const detail = await axios.get(
      `${API_URL}/examinations/${dateId}?populate=examiner.user`,
      headerRequest
    );
    const examinationDetail = detail.data.data;
    setDetail(examinationDetail);

    // Examinador de esa fecha, Admin, o Luis Guz
    if (
      examinationDetail.attributes.examiner.data?.id === usuario.id ||
      examinationDetail.attributes.examiner.data?.attributes.user?.data.id ===
        usuario.id ||
      usuario.docNumber === "8519212" ||
      usuario.level === 3
    ) {
      setCanQualify(true);
    }

    const res = await axios.get(
      `${API_URL}/temp-exams?populate=*&filters[examination][id][$eq]=${dateId}`,
      headerRequest
    );
    const exams = res.data.data;

    Promise.all(
      exams.map(async (exam) => {
        exam.grade = GetGradeName(gradesList, exam.attributes.grade_id);
        exam.dojo = GetDojoName(dojosList, exam.attributes.dojo_id);

        const tempUser = exam.attributes.tempUser;
        if (tempUser && tempUser.data && tempUser.data.id) {
          exam.fullname =
            tempUser.data.attributes.lastname +
            ", " +
            tempUser.data.attributes.name;
          exam.tempUserId = tempUser.data.id;
        }

        return exam;
      })
    ).then((exams) => {
      setExams(exams);
      setLoading(false);
    });
  };

  function MapState(state) {
    if (state === STATE_APPROVED) return "Aprobado";
    if (state === STATE_CREATED) return "Aprobado";
    if (state === STATE_UPDATED) return "Aprobado";
    if (state === STATE_ABSENT) return "Ausente";
    if (state === STATE_NOTAPPROVED) return "Desaprobado";
    return "Pendiente";
  }

  const ExamUpdate = (id, newState) => {
    setLoading(true);
    const reqExam = {
      data: {
        state: newState,
      },
    };
    axios
      .put(`${API_URL}/temp-exams/${id}`, reqExam, headerRequest)
      .then(() => {
        setLoading(false);
        GetExams();
      });
  };

  const renderData = (
    <Table striped hover size="sm" responsive="sm">
      <thead>
        <tr>
          <th className="d-none d-md-table-cell">DNI</th>
          <th>Nombre</th>
          <th className="d-none d-md-table-cell">Grado</th>
          <th className="d-none d-lg-table-cell">Dojo</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {exams.length < 1 ? (
          <tr>
            <td colSpan="5" align="center">
              No hay exámenes.
            </td>
          </tr>
        ) : (
          exams.map((exam) => (
            <tr key={exam.id}>
              <td align="center" className="d-none d-md-table-cell">
                {exam.attributes.docNumber}
              </td>
              <td align="left">{exam.fullname}</td>
              <td align="center" className="d-none d-md-table-cell">
                {exam.grade}
              </td>
              <td align="left" className="d-none d-lg-table-cell">
                {exam.dojo}
              </td>
              <td align="center" className="w270">
                {canQualify ? (
                  exam.attributes.state === "DRAFT" ? (
                    <>
                      <Button
                        size="sm"
                        className="m-1 p-2"
                        onClick={() => ExamUpdate(exam.id, STATE_APPROVED)}
                        variant="success"
                      >
                        Aprobar
                      </Button>
                      <Button
                        size="sm"
                        className="m-1 p-2"
                        onClick={() => ExamUpdate(exam.id, STATE_ABSENT)}
                        variant="warning"
                      >
                        Ausente
                      </Button>
                      <Button
                        size="sm"
                        className="m-1 p-2"
                        onClick={() => ExamUpdate(exam.id, STATE_NOTAPPROVED)}
                        variant="danger"
                      >
                        Desaprobar
                      </Button>
                    </>
                  ) : (
                    <Button disabled variant="outline-secondary">
                      {MapState(exam.attributes.state)}
                    </Button>
                  )
                ) : (
                  "En evaluación"
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <p style={{ textAlign: "left" }}>
        <Button size="sm" variant="primary" onClick={history.goBack}>
          VOLVER
        </Button>
      </p>
      <h4>DIA DE EXAMEN</h4>
      {detail ? (
        <p>
          Fecha: <b>{detail.attributes.date}</b>, Modalidad:{" "}
          <b>{detail.attributes.mode}</b>, Grado:{" "}
          <b>{detail.attributes.rank}</b>
        </p>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
